{
  "version": 1,
  "asset_id": "735c1b49-93d0-4071-a716-51090d9e8f20",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/735c1b49-93d0-4071-a716-51090d9e8f20/loc-san-antonio-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/735c1b49-93d0-4071-a716-51090d9e8f20/loc-san-antonio-640.webp",
  "original_filename": "loc-san-antonio-640.webp",
  "size": 35336,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:34Z"
}
